import * as stylex from "@stylexjs/stylex";
import { useId } from "react";
import "../tokens.stylex.ts";
import { color, fontSize, fontWeight } from "../tokens.stylex.ts";

/**
 * The Nudgebox mark (a raised tile — dotted face on a hatched slab — with a
 * notification dot in its top-right corner) and wordmark. `compact` shows the
 * mark only; `size` is the mark's edge in pixels. Colors come from the theme
 * tokens, so the mark follows dark mode.
 */
export function Logo({
  compact = false,
  size = 22
}: {
  compact?: boolean;
  size?: number;
}) {
  const id = useId();
  const hatch = `${id}-hatch`;
  const dots = `${id}-dots`;
  const fade = `${id}-fade`;
  return <span className="x3nfvp2 x6s0dn4 x167g77z">
      <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden className="x1lliihq x2lah0s">
        <defs>
          <pattern id={hatch} width="2.4" height="2.4" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <rect width="0.5" height="2.4" className="xiv5d04" />
          </pattern>
          <pattern id={dots} width="2.8" height="2.8" patternUnits="userSpaceOnUse" x="0.6" y="0.6">
            <circle cx="1.4" cy="1.4" r="0.32" className="xoib09s xti2d7y" />
          </pattern>
          <linearGradient id={fade} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0.3" className="x1q6hk0l" />
            <stop offset="1" stopOpacity="0" className="x1q6hk0l" />
          </linearGradient>
        </defs>
        {/* Slab: offset down-left, like `surface.raised`. */}
        <rect x="2.5" y="8.5" width="21" height="21" rx="5" strokeWidth="0.75" className="x1a0l9h8 x167lvmr" />
        <rect x="2.5" y="8.5" width="21" height="21" rx="5" fill={`url(#${hatch})`} />
        {/* Face: dot grid fading in toward the bottom. */}
        <rect x="6.5" y="4.5" width="21" height="21" rx="5" className="x1fak9ly" />
        <rect x="6.5" y="4.5" width="21" height="21" rx="5" fill={`url(#${dots})`} />
        <rect x="6.5" y="4.5" width="21" height="21" rx="5" fill={`url(#${fade})`} strokeWidth="0.75" className="xxw7k7h x1jhn8ml" />
        {/* The notification. */}
        <circle cx="26" cy="6" r="3.6" strokeWidth="1.4" className="xls0rk9 x5jx6h0" />
      </svg>
      {compact ? null : <span className="x1p23z6u x1ivwu1z x72az59 x9aqtqa">Nudgebox</span>}
    </span>;
}